exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container[data-v-cd5c06b2]{grid-area:SN;display:flex;align-items:center;justify-content:space-between;background-color:var(--secondary);padding:0 11px 0 16px;box-shadow:1px 0 0 rgba(0,0,0,.8);z-index:2}.title[data-v-cd5c06b2]{color:var(--white);font-size:16px;font-weight:700}.icon[data-v-cd5c06b2]{color:var(--white)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-cd5c06b2","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Server-Name/index.vue
// module id = 47
// module chunks = 0